<template>
    <div style="display:flex; align-items:center; justify-content:center; margin-top:-50px" v-if="productdetail">
        <div style="position:relative; width:816px; height:1056px; background:#fff;">

            <specsheet-header :prodstyle="productdetail.prod_key"></specsheet-header>
                <div style="padding: 20px 70px;">
                    <div class="left" style="float: left; width:374px; padding-right:25px;">

                            <!-- <specsheet-prodimage :prodImagesrc="prodImage[0].img" :prodimgfolder="prodImage[0].folder"></specsheet-prodimage> -->
                        <div class="specsheet-img">
                            <div v-if="prodImage.length!=0 ">
                                <specsheet-prodimage  :prodImageDetail="prodImage"></specsheet-prodimage>
                            </div>
                            <div v-else>
                                <img src="/images/products/img-coming-soon.png" alt="image" >
                            </div>
                        </div>




                        <specsheet-description :description="productdetail.short_desc" :brand="productdetail.brand"></specsheet-description>

                        <specsheet-features :product="productdetail" v-if="productdetail"></specsheet-features>
                        <specsheet-applications :applications="productdetail.apps" v-if="productdetail.apps"></specsheet-applications>

                    </div>
                    <div class="right" style="float: left; width:300px;" >
                        <section class="mt-3">
                            <product-icons :product="productdetail"></product-icons>
                        </section>
                        <specsheet-techdata :product="productdetail" v-if="productdetail"></specsheet-techdata>
                        <specsheet-performdata :product="productdetail" v-if="productdetail"></specsheet-performdata>
                        <specsheet-careinstruct :product="productdetail" v-if="productdetail"></specsheet-careinstruct>
                    </div>
                </div>
            <specsheet-footer></specsheet-footer>
        </div>
    </div>


</template>
<style  lang="scss">
.specsheet-img img{
    width:300px; height:300px;
}

</style>
<script>
import { mapState } from "vuex";

export default {
    data(){
        return {
            productdetail:{},
            prodImage:[],

        }
    },
    created(){
        axios.get(`/api/productWithSku/${this.$route.params.id}`).then(response => {
           this.productdetail=response.data[0];
            this.prodImage=this.productdetail.images;
        });
    }
};
</script>
